/**
 * DEX Public Verification Registry - proof-of-concept
 * Static JSON lookup. No backend dependency.
 */
(function () {
  var registryData = null;
  var dataUrl = window.__dexRegistryUrl || '';
  dataUrl = dataUrl.replace('dex-registry-data.json', 'dex-registry-data-20260616.json');

  var CARD_THEMES = {
    global: {
      gradStart: "#0a0f17",
      gradMid: "#12314a",
      gradEnd: "#041f42",
      imageRing: "#4a6687",
      glow: "rgba(18,49,74,0.22)"
    },
    management: {
      gradStart: "#08365f",
      gradMid: "#08365f",
      gradEnd: "#0e4f8a",
      imageRing: "#5c7a96",
      glow: "rgba(14,79,138,0.18)"
    },
    professional: {
      gradStart: "#0c467c",
      gradMid: "#15558f",
      gradEnd: "#1560b8",
      imageRing: "#6b8aa8",
      glow: "rgba(21,96,184,0.18)"
    }
  };

  function fetchData(callback) {
    if (registryData) {
      callback(null, registryData);
      return;
    }

    if (!dataUrl) {
      callback('Registry data source not configured.', null);
      return;
    }

    var cacheBustUrl = dataUrl + (dataUrl.indexOf('?') >= 0 ? '&' : '?') + 't=' + Date.now();

    var xhr = new XMLHttpRequest();
    xhr.open('GET', cacheBustUrl, true);

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          registryData = JSON.parse(xhr.responseText);
          callback(null, registryData);
        } catch (e) {
          callback('Registry data could not be read. Please try again later.', null);
        }
      } else {
        callback('Unable to load registry data. Please try again later.', null);
      }
    };

    xhr.onerror = function () {
      callback('Unable to connect to the registry. Please try again later.', null);
    };

    xhr.send();
  }

  function normalizeCode(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function formatCode(value) {
    var compact = normalizeCode(value).slice(0, 12);
    var groups = compact.match(/.{1,3}/g);
    return groups ? groups.join('-') : '';
  }

  function searchByCode(query, data) {
    var q = normalizeCode(query);
    if (!q) return [];

    return data.filter(function (row) {
      return normalizeCode(row.code || row.credentialId) === q;
    });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  function escAttr(str) {
    return esc(str).replace(/"/g, '&quot;');
  }

  function getTheme(record) {
    var key = record.themeKey || 'global';
    return CARD_THEMES[key] || CARD_THEMES.global;
  }

  function getThemeStyle(record) {
    var t = getTheme(record);

    return [
      '--dex-card-grad-start:' + t.gradStart,
      '--dex-card-grad-mid:' + t.gradMid,
      '--dex-card-grad-end:' + t.gradEnd,
      '--dex-card-image-ring:' + t.imageRing,
      '--dex-card-glow:' + t.glow
    ].join(';');
  }

  function resultArea() {
    return document.querySelector('[data-dex-registry-result]');
  }

  function inputEl() {
    return document.querySelector('[data-dex-registry-search] input[type="text"]');
  }

  function hideLandingMessage() {
    var empty = document.querySelector('[data-dex-registry-empty]');
    if (empty) empty.style.display = 'none';
  }

  function showResultArea(area) {
    hideLandingMessage();
    area.style.display = 'block';
  }

  function resetSearch() {
    var input = inputEl();
    var area = resultArea();

    if (input) {
      input.value = '';
      input.focus();
    }

    if (area) {
      area.innerHTML = '';
      area.style.display = 'none';
    }

    hideLandingMessage();

    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  function renderLoading(area) {
    area.innerHTML =
      '<div class="dex-reg-card dex-reg-card--not-found">' +
        '<div class="dex-reg-notfound-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
        '</div>' +
        '<div class="dex-reg-notfound-title">Searching the registry...</div>' +
      '</div>';

    showResultArea(area);
  }

  function renderError(msg, area) {
    area.innerHTML =
      '<div class="dex-reg-card dex-reg-card--not-found">' +
        '<div class="dex-reg-notfound-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
        '</div>' +
        '<div class="dex-reg-notfound-title">Registry unavailable</div>' +
        '<p class="dex-reg-notfound-text">' + esc(msg) + '</p>' +
      '</div>';

    showResultArea(area);
  }

  function renderNotFound(query, area) {
    area.innerHTML =
      '<div class="dex-reg-card dex-reg-card--not-found">' +
        '<div class="dex-reg-notfound-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35"/><path d="M8 11h6"/></svg>' +
        '</div>' +
        '<div class="dex-reg-notfound-title">No credential record found</div>' +
      '<p class="dex-reg-notfound-text">No results found for <strong>' + esc(formatCode(query) || query) + '</strong>. Please check the credential code and try again. Dashes and spaces are optional.</p>' +
      '</div>';

    showResultArea(area);
  }

  function renderCredential(record, area) {
    var shareUrl = record.shareUrl || ('/pages/verification?credential=' + encodeURIComponent(record.credentialId || record.code));
    var themeKey = record.themeKey || 'global';

    area.innerHTML =
      '<div class="dex-reg-result-stack">' +
        '<div class="dex-reg-card" data-theme-key="' + escAttr(themeKey) + '" data-certification="' + escAttr(record.certificationCode || '') + '" style="' + escAttr(getThemeStyle(record)) + '">' +
          '<div class="dex-reg-card__head">' +
            '<span class="dex-reg-tier"><span class="dex-reg-dot"></span>' + esc(record.certificationCode) + '</span>' +
            '<span class="dex-reg-status">&#10003; Active</span>' +
          '</div>' +

          '<div class="dex-reg-title-row">' +
            '<div class="dex-reg-title-copy">' +
              '<div class="dex-reg-name">' + esc(record.title) + '</div>' +
              '<div class="dex-reg-sub">' + esc(record.productName) + '</div>' +
            '</div>' +
            '<div class="dex-reg-thumb">' +
              '<img src="' + escAttr(record.badgeImage) + '" alt="' + escAttr(record.badgeAlt || record.title) + '" width="96" height="96" loading="lazy">' +
            '</div>' +
          '</div>' +

          '<div class="dex-reg-grid dex-reg-grid--structured">' +
            '<div class="dex-reg-full"><div class="dex-reg-label">Holder Name</div><div class="dex-reg-value">' + esc(record.holderName) + '</div></div>' +
            '<div><div class="dex-reg-label">Domain</div><div class="dex-reg-value">' + esc(record.domain) + '</div></div>' +
            '<div><div class="dex-reg-label">Level</div><div class="dex-reg-value">' + esc(record.level) + '</div></div>' +
            '<div><div class="dex-reg-label">Member Since</div><div class="dex-reg-value">' + esc(record.memberSince) + '</div></div>' +
            '<div><div class="dex-reg-label">Renews</div><div class="dex-reg-value">' + esc(record.renews) + '</div></div>' +
          '</div>' +

          '<div class="dex-reg-code-row">' +
            '<div>' +
              '<div class="dex-reg-label">Credential ID</div>' +
              '<div class="dex-reg-code">' + esc(record.credentialId || record.code) + '</div>' +
            '</div>' +
            '<a class="dex-reg-link" href="' + escAttr(shareUrl) + '" target="_blank" rel="noopener" aria-label="Open shareable credential verification">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>' +
            '</a>' +
          '</div>' +

          '<div class="dex-reg-foot">' +
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
            '<span>' + esc(record.verificationNote) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    showResultArea(area);
  }

  function runLookup(query) {
    var area = resultArea();
    if (!normalizeCode(query) || !area) return;

    renderLoading(area);

    fetchData(function (err, data) {
      if (err) {
        renderError(err, area);
        return;
      }

      var results = searchByCode(query, data);

      if (!results.length) {
        renderNotFound(query, area);
        return;
      }

      renderCredential(results[0], area);
    });
  }

  function init() {
    hideLandingMessage();

    var forms = document.querySelectorAll('[data-dex-registry-search]');
    forms.forEach(function (form) {
      if (form.dataset.dexRegistryBound === 'true') return;
      form.dataset.dexRegistryBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = form.querySelector('input[type="text"]');
        var query = input ? input.value : '';
        if (input) input.value = formatCode(query);

        runLookup(query);
      });

      var input = form.querySelector('input[type="text"]');
      if (input) {
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocapitalize', 'characters');
        input.setAttribute('spellcheck', 'false');

        input.addEventListener('input', function () {
          var formatted = formatCode(input.value);
          if (input.value !== formatted) input.value = formatted;
        });
      }
    });

    var params = new URLSearchParams(window.location.search);
    var sharedCode = params.get('credential');

    if (sharedCode && document.body.dataset.dexSharedCredentialLoaded !== sharedCode) {
      document.body.dataset.dexSharedCredentialLoaded = sharedCode;

      var input = inputEl();
      if (input) input.value = formatCode(sharedCode);

      runLookup(sharedCode);
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dex-registry-reset]')) {
      resetSearch();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    registryData = null;
    init();
  });
})();
